<shared-modal [mobile]="sharedService.screenSize !== 'l'" height="400px">
  <!-- header -->
  <h2 slot="header" class="flex">
    Editar conta – {{ userService.organization()?.name }}
    <span
      class="material-symbols-rounded cursor-pointer ml-auto"
      (click)="sharedService.closeModal(route)"
      >close</span
    >
  </h2>

  <section class="flex flex-col gap-4">
    @if (portalLinkLoading()) {
      <kor-spinner></kor-spinner>
    } @else {
      <div
        class="blu-menu-item w-full"
        (click)="
          createDashboardLink();
          analyticsService.logEvent('header_subscription-tag_click')
        "
      >
        Alterar plano ({{ userService.organization()?.subscription?.plan }})
      </div>
    }
  </section>
</shared-modal>
